import {
  FileTextOutlined,
  CoffeeOutlined,
  AppstoreOutlined,
  CarOutlined,
  UserOutlined,
  DesktopOutlined,
  InboxOutlined,
  BoxPlotOutlined,
} from "@ant-design/icons";
import { KASIR_PREFIX_PATH } from "configs/AppConfig";

const dashBoardNavTree = [
  {
    key: "transaksi",
    path: `${KASIR_PREFIX_PATH}/transaksi`,
    title: "Transaksi",
    icon: DesktopOutlined,
    breadcrumb: false,
    submenu: [],
  },
  {
    key: "stok-harian",
    path: `${KASIR_PREFIX_PATH}/stok-harian`,
    title: "Stok Harian",
    icon: AppstoreOutlined,
    breadcrumb: false,
    submenu: [],
  },
  {
    key: "laporan-penjualan",
    path: `${KASIR_PREFIX_PATH}/laporan-penjualan`,
    title: "Laporan Penjualan",
    icon: FileTextOutlined,
    breadcrumb: false,
    submenu: [],
  },
  {
    key: "pengiriman-produk",
    path: `${KASIR_PREFIX_PATH}/pengiriman-produk`,
    title: "Pengiriman Produk",
    icon: InboxOutlined,
    breadcrumb: false,
    submenu: [],
  },
  {
    key: "delivery",
    path: `${KASIR_PREFIX_PATH}/delivery`,
    title: "Delivery",
    icon: CarOutlined,
    breadcrumb: false,
    submenu: [],
  },
  {
    key: "item",
    path: `${KASIR_PREFIX_PATH}/item/9d17c07d-1247-47a8-9537-0d8e080d29c7`,
    title: "Item",
    icon: BoxPlotOutlined,
    breadcrumb: false,
    submenu: [],
  },
  {
    key: "vendor",
    path: `${KASIR_PREFIX_PATH}/vendor/9d17c07d-1247-47a8-9537-0d8e080d29c7`,
    title: "Vendor",
    icon: CoffeeOutlined,
    breadcrumb: false,
    submenu: [],
  },
  {
    key: "closing",
    path: "",
    title: localStorage.statusClosing,
    icon: UserOutlined,
    breadcrumb: false,
    submenu: [],
  },
];

const navigationConfig = [...dashBoardNavTree];

export default navigationConfig;
